module.exports = __webpack_public_path__ + "dde446e2010a21631ce978133efb8953.svg";